module.exports = __webpack_public_path__ + "static/media/logo.1fc45a8c.png";